<div cdk-overlay-container>
	<div mat-dialog-container>
		<div mat-dialog-content>
			<ng-template #dynamicComponentContainer></ng-template>
		</div>
		<div mat-dialog-actions>
			<button mat-button (click)="close()">Close</button>
		</div>
	</div>
</div>
